export const formatNumber = number => {
  if (number == undefined) return "0"
  let parts = number.toString().split(".")
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  return parts.join(".")
}

/**
 * Function to format a number with suffixes for thousands, millions, and billions.
 * @param {number} number - The number to be formatted.
 * @returns {string} The formatted number with suffixes.
 */

export function numberWithSuffix(number) {
  if (!number) return "0"
  // Use the toLocaleString method to add suffixes to the number
  return number.toLocaleString("en-US", {
    // add suffixes for thousands, millions, and billions
    // the maximum number of decimal places to use
    maximumFractionDigits: 2,
    // specify the abbreviations to use for the suffixes
    notation: "compact",
    compactDisplay: "short"
  })
}
